import { useQuery } from '@tanstack/react-query';
import { Option } from '../models';
import QUERY_KEYS from '../utils/QueryKeys';

// Mirrors useBuyAllOption, but resolves the DEDICATED senior "$99.95 buy-all"
// promo Option (distinct from the package screen's full-price "All Digital"
// buy-all). The promo Option carries the headline price the upsell displays.
export default function useSeniorBuyAllPromoOption(packageId, schoolId) {
  return useQuery([QUERY_KEYS.SENIOR_BUY_ALL_PROMO_OPTION, packageId], () => (
    Option
      .where({ packageId, seniorBuyAllPromo: schoolId })
      .first()
      .then((res) => res.data)
  ), { enabled: !!(packageId && schoolId), placeholderData: null });
}
